Vue.component('ack-curo-resins-product', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-curo-resins-product',
	created() {
		this.selectAvailableVariant();
	},
	mounted() {},
	props: {
		isShowProductMenu: {
			type: Boolean,
			required: false,
			default: true,
		},
		productId: {
			type: String,
			required: true,
		},
		productShopify: {
			type: Object,
			required: true,
		},
		menuItems: {
			type: Array,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		isShowApplicationText: {
			type: Boolean,
			required: false,
			default: true,
		},
		isShowBuyBtn: {
			type: Boolean,
			default: true,
			required: false,
		},
		purchaseControlMode: {
			type: String,
			required: false,
			default: 'variant',
		},
	},
	computed: {
		...Vuex.mapGetters('shop', ['isStoreAvailable']),
		...Vuex.mapGetters('resins', ['activeItem']),
		...Vuex.mapGetters('localization', ['countryCode', 'isUS_CA', 'isIreland']),

		isUSorCA() {
			return this.countryCode.toUpperCase() === 'US' || this.countryCode.toUpperCase() === 'CA';
		},

		isRestrictedProduct() {
			const restrictedProductIds = [
				'6627055435879', // CURO Crown
				'6624780812391', // CURO Model
				'6624785760359', // CURO proDenture
				'6627062448231', // CURO ProSplint Soft
			];

			// Extract the product ID from the full Shopify URL
			const productId = this.productId.split('/').pop();

			return (restrictedProductIds.includes(productId) && this.isUSorCA) || this.isIreland;
		},

		isPurchaseTemporarilyDisabled() {
			return isProductPurchaseTemporarilyDisabled(this.productId);
		},

		hasChartsOrImages() {
			return (
				this.charts.some((chart) => chart && chart !== '') ||
				this.chartsImages.some((image) => image && image !== '')
			);
		},

		featuresList() {
			let list = [];
			let fNum = parseInt(this.$t(`resins.collection.${this.productId}.bullet_points_count`));
			for (let index = 0; index < fNum; index++) {
				const feature = this.$t(`resins.collection.${this.productId}.bullet_points.${index}`);
				list.push(feature);
			}
			return list;
		},
		kitContainsList() {
			let list = [];
			let fNum = parseInt(this.$t(`resins.collection.${this.productId}.bullet_points_kit_count`));
			for (let index = 0; index < fNum; index++) {
				const feature = this.$t(`resins.collection.${this.productId}.bullet_points_kit.${index}`);
				list.push(feature);
			}
			return list;
		},
		kitContainsColumns() {
			const list = this.kitContainsList.filter((item) => item && item !== '');
			const leftCountKey = `resins.collection.${this.productId}.bullet_points_kit_left_count`;
			const configuredLeftCount =
				this.$te && this.$te(leftCountKey) ? parseInt(this.$t(leftCountKey)) : NaN;
			const leftCount = Number.isNaN(configuredLeftCount)
				? Math.ceil(list.length / 2)
				: configuredLeftCount;
			const splitIndex = Math.min(Math.max(leftCount, 1), list.length);

			return [list.slice(0, splitIndex), list.slice(splitIndex)].filter(
				(column) => column.length > 0,
			);
		},
		hasFeaturesList() {
			return this.featuresList.some((feature) => feature && feature !== '');
		},
		hasKitContainsList() {
			return this.kitContainsList.some((item) => item && item !== '');
		},
		hasDownloadLinks() {
			return Boolean(
				this.getUrl('instructions_for_use_url') ||
					this.getUrls('instructions_for_use_urls') ||
					this.getUrl('safety_data_sheet_url') ||
					this.getUrl('sales_sheet_url') ||
					this.getUrl('stain_and_glaze_guide_url') ||
					this.getUrl('technical_specifications_url') ||
					this.validatedDevicesUrl,
			);
		},
		showValidatedDevices() {
			return String(this.productId) !== '7412868808807';
		},
		validatedDevicesUrl() {
			if (!this.showValidatedDevices) return '';
			return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Validated_Devices.pdf?v=1782718963';
		},
		imageSrc() {
			if (String(this.productId) === '7346161123431') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement.png?v=1782108963';
			}

			if (String(this.productId) === '7412868808807') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner.png?v=1782108402';
			}

			if (String(this.productId) === '6908625911911') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0.png?v=1782113560';
			}

			if (String(this.productId) === '7499834064999') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint_2.0_Rigid.png?v=1782096446';
			}

			if (String(this.productId) === '7499835900007') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint.png?v=1782096226';
			}

			if (String(this.productId) === '6908632727655') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Base_2.0.png?v=1782094153';
			}

			if (String(this.productId) === '7346083889255') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Try-In.png?v=1781666675';
			}

			if (String(this.productId) === '7419335999591') {
				return this.truModelImageSrc;
			}

			if (String(this.productId) === '7499845599335') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Surgical_Guide_2.0.png?v=1781674438';
			}

			if (String(this.productId) === '7499855003751') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Ortho_IBT.png?v=1781747036';
			}

			if (String(this.productId) === '7499855855719') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Castable.png?v=1781748070';
			}

			if (String(this.productId) === '7499848220775') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Bite_Tray.png?v=1781748130';
			}

			if (String(this.productId) === '6908636790887') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Bond_Dental_Adhesive_Kit.png?v=1781748301';
			}

			if (String(this.productId) === '7345430462567') {
				return this.rapidCeramImageSrc;
			}

			if (String(this.productId) === '7345446813799') {
				return this.enVisionImageSrc;
			}

			if (String(this.productId) === '7419338063975') {
				return this.bioArchRpdImageSrc;
			}

			if (this.variants.length < 2) {
				return this.productShopify.images[0];
			}

			return this.selectedVariantRecord?.featured_image?.src || '';
		},
		rapidCeramImageSrc() {
			const imageByCapacity = {
				'300g':
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_300g.png?v=1782443213',
				'600g':
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_600g.png?v=1782443204',
			};
			const fallbackImage =
				'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram.png?v=1781595671';

			if (/(^|\D)300\s*g(\D|$)/.test(this.selectedVariantText)) {
				return imageByCapacity['300g'];
			}

			if (/(^|\D)600\s*g(\D|$)/.test(this.selectedVariantText)) {
				return imageByCapacity['600g'];
			}

			return fallbackImage;
		},
		enVisionImageSrc() {
			const kitImage =
				'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_-_Kit.png?v=1782443200';
			const resinImage =
				'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_dd7c281c-224f-485f-bb39-d855f76c4370.png?v=1782443199';

			return /\bkit\b/.test(this.selectedVariantText) ? kitImage : resinImage;
		},
		bioArchRpdImageSrc() {
			const imageByShade = {
				neutralRose:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_BioArch_RPD_Neutral_Rose.png?v=1782443214',
				meharry:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_BioArch_RPD_Meharry.png?v=1782443213',
				clear:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_BioArch_RPD_Clear.png?v=1782443201',
			};
			const fallbackImage =
				'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_BioArch_RPD.png?v=1781665279';

			if (/neutral\s*rose/.test(this.selectedVariantText)) {
				return imageByShade.neutralRose;
			}

			if (/\bmeharry\b/.test(this.selectedVariantText)) {
				return imageByShade.meharry;
			}

			if (/\bclear\b/.test(this.selectedVariantText)) {
				return imageByShade.clear;
			}

			return fallbackImage;
		},
		truModelImageSrc() {
			const imageByShadeAndCapacity = {
				sand1kg:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_TruModel_Sand_1kg.png?v=1782443214',
				gray4kg:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_TruModel_Gray_4kg.png?v=1782443214',
				prime4kg:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_TruModel_Prime_4kg.png?v=1782443201',
				prime1kg:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_TruModel_Prime_1kg.png?v=1782443214',
				gray1kg:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_TruModel_Gray_1kg.png?v=1782443214',
			};
			const fallbackImage =
				'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_TruModel.png?v=1781667601';
			const has1kg = /(^|\D)1\s*kg(\D|$)/.test(this.selectedVariantText);
			const has4kg = /(^|\D)4\s*kg(\D|$)/.test(this.selectedVariantText);

			if (/\bsand\b/.test(this.selectedVariantText) && has1kg) {
				return imageByShadeAndCapacity.sand1kg;
			}

			if (/\bgray\b/.test(this.selectedVariantText) && has4kg) {
				return imageByShadeAndCapacity.gray4kg;
			}

			if (/\bprime\b/.test(this.selectedVariantText) && has4kg) {
				return imageByShadeAndCapacity.prime4kg;
			}

			if (/\bprime\b/.test(this.selectedVariantText) && has1kg) {
				return imageByShadeAndCapacity.prime1kg;
			}

			if (/\bgray\b/.test(this.selectedVariantText) && has1kg) {
				return imageByShadeAndCapacity.gray1kg;
			}

			return fallbackImage;
		},

		chartsImages() {
			let list = [];
			let fNum = parseInt(
				this.$t(`resins.collection.${this.productId}.mechanical_properties_count`),
			);
			for (let index = 0; index < fNum; index++) {
				const image = this.$t(
					`resins.collection.${this.productId}.mechanical_properties.${index}.image`,
				);
				list.push(image);
			}
			return list;
		},
		chartsLabels() {
			let list = [];
			let fNum = parseInt(
				this.$t(`resins.collection.${this.productId}.mechanical_properties_count`),
			);
			for (let index = 0; index < fNum; index++) {
				const label = this.$t(
					`resins.collection.${this.productId}.mechanical_properties.${index}.label`,
				);
				list.push(label);
			}
			return list;
		},
		charts() {
			let list = [];
			let fNum = parseInt(
				this.$t(`resins.collection.${this.productId}.mechanical_properties_count`),
			);
			for (let index = 0; index < fNum; index++) {
				const chart = {
					color: this.$t(`resins.collection.${this.productId}.color`),
					value: this.$t(
						`resins.collection.${this.productId}.mechanical_properties.${index}.value`,
					),
				};
				list.push(ChartOptions.getChartOptions(chart));
			}
			return list;
		},
		variants() {
			const inventoryLocations = [
				INVENTORY_LOCATION_US,
				INVENTORY_LOCATION_TW,
				INVENTORY_LOCATION_US_2,
				INVENTORY_LOCATION_TW_2,
			];

			return this.productShopify.variants
				.filter((variant) => {
					const locationName = variant.option1;
					const hasLocation = inventoryLocations.includes(locationName);
					if (hasLocation) {
						const isUsCa =
							locationName === INVENTORY_LOCATION_US || locationName === INVENTORY_LOCATION_US_2;
						const isTw =
							locationName === INVENTORY_LOCATION_TW || locationName === INVENTORY_LOCATION_TW_2;
						return this.isUS_CA ? isUsCa : isTw;
					}
					return variant;
				})
				.map((variant) => {
					const locationName = variant.option1;
					const hasLocation = inventoryLocations.includes(locationName);
					const locationPosition = 0;
					const excludeLocation = (_, i) => i !== locationPosition;
					const newName = (name) =>
						hasLocation ? name.split(' / ').filter(excludeLocation).join(' / ') : name;
					return {
						...variant,
						public_title: newName(variant.public_title),
						title: newName(variant.title),
					};
				});
		},
		selectedVariantRecord() {
			if (!this.selectedVariant) {
				return null;
			}

			return (
				this.variants.find((variant) => {
					return String(variant.id) === String(this.selectedVariant.value);
				}) || null
			);
		},
		selectedVariantText() {
			return [
				this.selectedVariantRecord?.title,
				this.selectedVariantRecord?.public_title,
				this.selectedVariantRecord?.option1,
				this.selectedVariantRecord?.option2,
				this.selectedVariantRecord?.option3,
				this.selectedVariant?.label,
			]
				.filter(Boolean)
				.join(' ')
				.toLowerCase();
		},
		selectVariantsOptions() {
			let list = [];
			for (let index = 0; index < this.variants.length; index++) {
				const element = this.variants[index];
				let opt = {
					label: element.title,
					value: element.id,
				};
				list.push(opt);
			}
			return list;
		},
		unavailableProduct() {
			const unavailableProductsIds = [
				'6624780812391', // CURO Model Yellow
			];
			// Extract the product ID from the full Shopify URL
			const productId = this.productId.split('/').pop();
			return unavailableProductsIds.includes(productId);
		},
		isSoldOut() {
			if (this.variants.length < 2) {
				return this.productShopify.available === false;
			}

			return this.selectedVariantRecord ? this.selectedVariantRecord.available === false : true;
		},
		hasInlineCartButton() {
			const inlineCartProductIds = [
				'7499845599335',
				'7499855003751',
				'7499855855719',
				'7499848220775',
				'6908636790887',
			];

			return (
				this.purchaseControlMode === 'button' ||
				(this.purchaseControlMode === 'variant' &&
					inlineCartProductIds.includes(String(this.productId)))
			);
		},
		usesStackedPurchaseLayout() {
			const stackedPurchaseProductIds = [
				'7346083889255', // Rodin Try-In
				'7346161123431', // Rodin Luting Cement
				'7499855855719', // Rodin Castable
				'7211636359271', // Rodin N2-Free Glaze
				'7211598381159', // N2-Free Palette Naturalizing Kit
				'7412868808807', // Rodin Resin Cleaner
				'6908636790887', // Rodin Bond Dental Adhesive Bottle Kit
				'7499835900007', // Rodin Flexisplint
				'7499834064999', // Rodin Splint 2
				'7499855003751', // Rodin Ortho IBT
				'7499848220775', // Rodin Bite Tray
				'7499845599335', // Rodin Surgical Guide 2
			];

			return stackedPurchaseProductIds.includes(String(this.productId));
		},
	},
	data() {
		return {
			selectedVariant: null,
			quantity: 1,
			iconColor: '#000000',
			showMenu: true,
			showModal: false,
		};
	},
	methods: {
		...Vuex.mapActions('shop', ['buyNow', 'addToCartFromProperties']),
		...Vuex.mapActions('resins', ['menuItemClick']),
		getUrl(key) {
			if (key === 'instructions_for_use_url' && String(this.productId) === '7419338063975') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_BioArch_RPD_Instructions_for_Use.pdf?v=1780909377';
			}

			if (key === 'technical_specifications_url' && String(this.productId) === '7419338063975') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_BioArch_RPD_52026.indd.pdf?v=1781745925';
			}

			if (key === 'technical_specifications_url' && String(this.productId) === '7346083889255') {
				return 'https://cdn.ackuretta.com/downloads/pac-dent/TDS/TDS-RODIN%20TRY%20IN.pdf?_gl=1*p1867n*_gcl_au*MTUzODcwNzMwMy4xNzgwMjk1OTA2*FPAU*MTUzODcwNzMwMy4xNzgwMjk1OTA2';
			}

			if (key === 'stain_and_glaze_guide_url' && String(this.productId) === '7211598381159') {
				return 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_palette_kit_2.0_IFU.pdf?v=1782107874';
			}

			const url = this.$t('resins.collection.' + this.productId + '.' + key);
			return url !== 'resins.collection.' + this.productId + '.' + key ? url : null;
		},
		getUrls(key) {
			if (typeof this.$t('resins.collection.' + this.productId + '.' + key) === 'string') {
				return false;
			}

			return this.$t('resins.collection.' + this.productId + '.' + key);
		},
		onIncreaseQuantityClick() {
			this.quantity++;
		},
		onDecreaseQuantityClick() {
			if (this.quantity > 1) {
				this.quantity--;
			}
		},
		onBuyNowClick() {
			if (this.isPurchaseTemporarilyDisabled) return;

			this.buyNow({
				variantId: `gid://shopify/ProductVariant/${this.selectedVariant.value}`,
				quantity: this.quantity,
			}).then((url) => {
				openCheckoutUrl(url);
			});
		},
		onAddToCartClick() {
			if (this.unavailableProduct || this.isPurchaseTemporarilyDisabled) {
				console.log('Attempted to add a restricted product to the cart:', this.productId);
				return;
			}

			let imgOverride = null;

			if (String(this.productId) === '7346161123431') {
				imgOverride =
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement.png?v=1782108963';
			} else if (String(this.productId) === '6908625911911') {
				imgOverride =
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0.png?v=1782113560';
			} else if (String(this.productId) === '7412868808807') {
				imgOverride =
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner.png?v=1782108402';
			} else if (String(this.productId) === '6908632727655') {
				imgOverride =
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Base_2.0.png?v=1782094153';
			} else if (String(this.productId) === '7499834064999') {
				imgOverride =
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint_2.0_Rigid.png?v=1782096446';
			} else if (String(this.productId) === '7499835900007') {
				imgOverride =
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint.png?v=1782096226';
			} else if (String(this.productId) === '7345430462567') {
				imgOverride = this.rapidCeramImageSrc;
			} else if (String(this.productId) === '7345446813799') {
				imgOverride = this.enVisionImageSrc;
			} else if (String(this.productId) === '7419338063975') {
				imgOverride = this.bioArchRpdImageSrc;
			} else if (String(this.productId) === '7419335999591') {
				imgOverride = this.truModelImageSrc;
			}

			this.addToCartFromProperties({
				productId: `gid://shopify/Product/${this.productId}`,
				variantId: `gid://shopify/ProductVariant/${this.selectedVariant.value}`,
				quantity: this.quantity,
				imgOverride,
			}).then(() => {
				EventBus.$emit('show-cart');
			});
		},
		selectAvailableVariant() {
			const variantIdFromUrl = new URLSearchParams(window.location.search).get('variant');
			if (variantIdFromUrl) {
				const matchedVariant = this.variants.find(
					(variant) => String(variant.id) === String(variantIdFromUrl),
				);
				if (matchedVariant) {
					this.selectedVariant = {
						value: matchedVariant.id,
						label: matchedVariant.title,
					};
					return;
				}
			}

			let availableVariant = this.variants.find((variant) => variant.available);
			if (availableVariant) {
				this.selectedVariant = { value: availableVariant.id, label: availableVariant.title };
			} else {
				this.selectedVariant = { value: this.variants[0].id, label: this.variants[0].title };
			}
		},
	},
	beforeDestroy() {},
	watch: {
		productId: {
			handler() {
				this.selectAvailableVariant();
			},
			immediate: true,
		},
	},
});
